import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';
import { AFAS_DAGDEELGEGEVENS_COLUMNS } from '../constants';
import { formatWtfNl } from '../utils/formatWtf';

const cellValue = (row, key) => {
    if (key === 'wtf') {
        return formatWtfNl(row.wtf ?? row.wtfPerDag ?? 0);
    }
    if (key === 'dagType') {
        return row.dagType || row.dagtype || '';
    }
    return row[key] ?? '';
};

/**
 * Read-only day-part detail popup (Figma: Dagdeelgegevens).
 */
const AfasDagdeelgegevensModal = ({ isOpen, rows = [], onClose }) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
            <ModalHeader toggle={onClose}>
                Dagdeelgegevens
            </ModalHeader>
            <ModalBody>
                <div className="table-responsive border rounded">
                    <Table hover size="sm" className="mb-0 align-middle">
                        <thead >
                            <tr>
                                {AFAS_DAGDEELGEGEVENS_COLUMNS.map((column) => (
                                    <th key={column.key} className="small fw-semibold text-muted">
                                        {column.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={AFAS_DAGDEELGEGEVENS_COLUMNS.length} className="text-center text-muted py-3">
                                        Geen dagdelen
                                    </td>
                                </tr>
                            ) : (
                                rows.map((row, index) => (
                                    <tr key={row.id ?? `${row.datum}-${index}`}>
                                        {AFAS_DAGDEELGEGEVENS_COLUMNS.map((column) => (
                                            <td key={column.key} className="small">
                                                {cellValue(row, column.key)}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-color-style" onClick={onClose}>
                    Scherm sluiten
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AfasDagdeelgegevensModal;
